(() => {
  let adding = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cl-cart-add]');
    if (!button || button.disabled || adding) return;
    event.preventDefault();
    const feedback = button.closest('.cl-cart-offer, .cl-cart-recs').querySelector('.cl-cart-feedback');
    const label = [...button.childNodes].map(node => node.cloneNode(true));
    const buttons = [...document.querySelectorAll('[data-cl-cart-add]:not(:disabled)')];
    adding = true;
    buttons.forEach(item => { item.disabled = true; });
    button.textContent = 'Se adaugă…';
    feedback.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.clCartAdd), quantity: 1, ...(button.dataset.clCartGift ? { properties: { Cadou: button.dataset.clCartGift } } : {}) }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Produsul nu a putut fi adăugat. Încearcă din nou.');
      feedback.textContent = 'Adăugat în coș. Actualizăm totalul…';
      window.location.assign(root + 'cart');
    } catch (error) {
      feedback.textContent = error.message || 'Conexiunea a fost întreruptă. Verifică-ți coșul înainte să încerci din nou.';
      buttons.forEach(item => { item.disabled = false; });
      button.replaceChildren(...label);
      adding = false;
    }
  });
})();
